import { Box } from '@mui/material';
import React, { FC, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Loading, ProtectedRoute, SideBar, SideNav } from '../../shared';
import { useDashboards } from '../hooks/use-dashboards.hook';
import { reportSubRoutes } from '../reports.routes';

export const ReportsPage: FC = () => {
    const { data: dashboards = [], isLoading } = useDashboards();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (dashboards.length && location.pathname === '/reports') {
            const reports = dashboards[0].reports;
            if (reports.length) navigate(`/reports/${reports[0].id}`);
        }
    }, [dashboards, navigate, location]);

    if (isLoading) return <Loading fullscreen />;
    return (
        <Box sx={{ display: 'flex' }}>
            <SideBar>
                <SideNav
                    items={[
                        ...dashboards.flatMap(({ id, name, reports }) => [
                            {
                                text: name,
                                key: id,
                            },
                            ...reports.map((report) => ({
                                path: `/reports/${report.id}`,
                                text: report.name,
                            })),
                        ]),
                    ]}
                />
            </SideBar>
            <Box sx={{ flex: 1 }}>
                <Routes>
                    {reportSubRoutes.map((subRoute) => (
                        <Route
                            key={subRoute.path}
                            path={subRoute.path}
                            element={
                                <ProtectedRoute requiredPermission={subRoute.requiredPermissions}>
                                    <subRoute.component />
                                </ProtectedRoute>
                            }
                        />
                    ))}
                </Routes>
            </Box>
        </Box>
    );
};
